<div class="modal-header">
  <h4 class="modal-title pull-left">{{ title }}</h4>
</div>
<div class="modal-body">
  @if (loading$ | async) {
    <div class="loading-div">
      <mat-progress-spinner color="primary" mode="indeterminate" />
    </div>
  }
  <div>
    @if (text) {
      <div>{{ text }}</div>
    }
    <br />
    @if (htmlSrc) {
      <!-- sandbox is required: srcdoc bypasses Angular's HTML sanitizer -->
      <iframe width="100%" height="500px" style="border: 0" sandbox [title]="title" [srcdoc]="htmlSrc"></iframe>
    }
  </div>
  <br />
  <br />
  <form class="form-horizontal" [formGroup]="form" autocomplete="off">
    <div class="form-group row d-flex justify-content-center">
      <label>
        <input type="checkbox" formControlName="acceptTerms" />
        <span>{{ 'Dialog.AcceptTermsDialog.AcceptTermsCheckboxText' | translate }}</span>
      </label>
    </div>
  </form>
</div>
<div class="modal-footer">
  <ng-container>
    @if (button_cancel_text) {
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        {{ button_cancel_text }}
      </button>
    }
    @if (button_confirm_text) {
      <button type="button" class="btn btn-secondary" (click)="onConfirm()" [disabled]="form.invalid">
        {{ button_confirm_text }}
      </button>
    }
  </ng-container>
</div>
